// extracted by mini-css-extract-plugin
export var divider = "_m7-0";
export var labelWrapper = "_m7-2";
export var lineSvg = "_m7-1";